import { Button, Modal } from "antd";
import { ShowToast, Severty } from "../helper/toast";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import useRequest from "../hooks/useRequest";

const { confirm } = Modal;

const ConfirmationBox = () => {
  const { request } = useRequest();

  const showConfirm = ({ record, path, onLoading, onSuccess, type, title, subtitle }) => {
    setTimeout(() => {
      confirm({
        className: "tab_modal",
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        content: (
          <p style={{ fontSize: "24px", fontWeight: "bold", textAlign: "center" }}>
            {subtitle || "Are you sure you want to change the status?"}
          </p>
        ),
        title: title || null,
        onOk() {
          statusChange(record, path, onLoading, onSuccess, type);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };


  const showDeleteConfirm = ({ record, path, onSuccess }) => {
    console.log("Show Delete Confirm", record);
    setTimeout(() => {
      confirm({
        className: "tab_modal",
        icon: <ExclamationCircleOutlined />,
        content: (
          <Button>Are you sure you want delete the selected columns ?</Button>
        ),
        onOk() {
          handleItemDelete(record, path, onSuccess);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const handleItemDelete = (record, path, onSuccess) => {
    console.log(path, "hfjdhfkdhkfhdk 43 from confirmation box");
    const url = path + "/" + record._id;
    request({
      url: url,
      method: "DELETE",
      onSuccess: (data) => {
        onSuccess();
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const statusChange = (record, path, onLoading, onSuccess, type) => {
    onLoading(true);
    let url = "";
    if (type !== null && type !== undefined) {
      url = path + "/" + type + "/" + record;
    } else {
      url = path + "/" + record;
    }
    request({
      url: url,
      method: "PUT",
      onSuccess: (data) => {
        onSuccess();
        onLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  return { showConfirm, showDeleteConfirm };
};

export default ConfirmationBox;
